var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{style:({'display': _vm.pwaInstallBtnVisibility}),on:{"click":function($event){return _vm.pwaInstaller()}}},[_c('b-icon',{attrs:{"icon":"cloud-download-fill"}}),_vm._v(" Instalar o "+_vm._s(_vm.appInitials)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }